import React from "react";
import {
  Button,
  Description,
  SubTitle,
} from "../../Components/CustomComponents";
import { Spinner } from "react-bootstrap";

export default function CourseComponent({
  image,
  title,
  description,
  enrollStatus,
  onSelect,
  trainingId,
  handleEnroll,
  isEnrolling,
}) {
  return (
    <div className={"courseCard cursor-pointer"} onClick={onSelect}>
      <img
        src={image}
        alt="Course"
        className={"courseImage"}
        onClick={onSelect}
      />
      <div className="d-flex flex-column justify-content-between ms-3">
        <SubTitle text={title} classes="lc-1" onClick={onSelect} />
        <Description text={description} classes={`lc-3`} onClick={onSelect} />
        {enrollStatus ? (
          <Button
            text="Enrolled"
            classes={`rounded-5 p-1 gradientBg`}
            type="submit"
          />
        ) :
          <Button
            text={isEnrolling ? <Spinner /> : "Enroll Now"}
            classes={`rounded-5 p-1 gradientBg z-3`}
            type="submit"
            onClick={isEnrolling ? () => { } : (e) => { e.stopPropagation(); handleEnroll(trainingId); }}
          />
        }
      </div>
    </div>
  );
}
